import type { BusinessUnitKey, BusinessUnitRuntime } from '@/modules/bu/registry.base';

/**
 * Discovered by filename, like `bu.routes.ts`, and out of `registry.base.ts` for
 * the same reason: a runtime pulls in its product's stores. Out of `registry.ts`
 * too, because stores import this file and the router reads `registry.ts` at
 * module scope: entering the cycle from here must not leave it half-initialised.
 * So nothing may read a runtime at module scope; ask from inside a function.
 */
const runtimeModules = import.meta.glob<{ key: BusinessUnitKey; default: BusinessUnitRuntime }>(
  '../*/bu.runtime.ts',
  { eager: true },
);

export const BUSINESS_UNIT_RUNTIMES = Object.values(runtimeModules).map((module) => module.default);

export const getBusinessUnitRuntime = (
  key_value: string | undefined,
): BusinessUnitRuntime | undefined =>
  Object.values(runtimeModules).find((module) => module.key === key_value)?.default;
